<!-- <!doctype html> -->
  <template>
    <header class="page-header">
      <nav class="navbar mega-menu" role="navigation">
        <div class="container-fluid">
          <div class="clearfix navbar-fixed-top">
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-responsive"> <span class="sr-only">Toggle navigation</span> <span class="toggle-icon"> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </span> </button>
            <a href="#" class="page-logo"><img :src="logo" width="133" height="25" alt="logo"></a>
            <div class="topbar-actions">
              <a href="#" style='position: relative; margin-right: 20px'>
                <img :src="noticeImg" @click="showUnreadNotice()" style="width:25px;">
              </a>
              <template v-if = "totalUnReadNoticeNum != 0">
                <span style="color:#FFF;background-color:#ff0000;display:block;width:20px;height:20px;border-radius:50%;text-align:center;line-height:20px;position:absolute;left:15px;top:0;font-size:12px;z-index: 999">{{totalUnReadNoticeNum}}</span>
              </template>
              <div class="btn-group btn-group-img">
                <button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-other="true"><img :src="userImg" alt="user-image" width="30"></button>
                <span class="login-name" v-html="realName"></span>
                <ul class="dropdown-menu-2tier" role="menu">
                  <li><a href="#" v-on:click="logout"><i class="fa fa-sign-out fa-fw"></i> 退出</a> </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="fixed-collapse">
          <div class="nav-collapse collapse navbar-collapse navbar-responsive">
            <ul class="nav navbar-nav" id="side-menu" v-html="menu">
              <!-- <li class="dropdown dropdown-fw active open selected"> <a href="javascript:;" class="text-uppercase"> <i class="icon-home"></i> 首页 </a>
                <ul class="dropdown-menu dropdown-menu-fw">
                  <li> <a href="#/"> <i class="icon-bar-chart"></i>首页</a> </li>
                  <li> <a href="#/bill"> <i class="icon-bulb"></i>账单</a> </li>
                  <li> <a href="#/search"> <i class="icon-graph"></i>搜索</a> </li>
                  <li> <a href="#/navi"> <i class="icon-graph"></i>菜单</a> </li>
                  <li> <a href="#/log"> <i class="icon-graph"></i>日志</a> </li>
                </ul>
              </li> -->
            </ul>
          </div>
        </div>
      </nav>
    </header>
  </template>

  <script>
  import axios from '@/axios/web'
  import {handleInit} from '@/components/js/app.js'
  import {handleHeaderMenu, activeMenu} from '@/components/js/layout.js'
  import {SERVICE_IP_PORT, RESOURCE_IP_PORT, REVIEW_SERVER} from '@/api/server'
  import NoticeServer from "@/api/notice";
  import {formatDate} from "element-ui/src/utils/date-util";
  import noticeConfig from "@/views/notice/noticeConfig"

  let that;

  export default {
    name: 'Header',

    mixins: [noticeConfig],

    data () {
      return {
        logo: require('@/assets/images/logo.png'),
        noticeImg: require('@/assets/images/notice-icon.svg'),
        userImg: require('@/assets/images/user-4.png'),
        menu: '',
        realName: '',

        totalUnReadNoticeNum: 0,  //未读消息总数
      }
    },
    methods: {
      logout:function() {
        axios.get('/AthubCloud/menu/logout.do').then(()=>{
          window.location.href=SERVICE_IP_PORT+"/welcome.jsp"
        });
      },

      getTotalUnReadNoticeNum() {
        NoticeServer.noticePerson.list({
          noticeDto: {
            previousDays: this.previousDays,
            endDate: formatDate(new Date(), 'yyyy-MM-dd'),
            status: "PUBLISHED",
          },
          personId: localStorage.getItem('userid'),
        }).then(res => {
          if (res.data.data.length > 0) {
            res.data.data = res.data.data.filter(e => {
              return e.readFlag == 0;
            });
            that.totalUnReadNoticeNum = res.data.data.length;
          } else {
            that.totalUnReadNoticeNum = 0;
          }
        });
      },

      showUnreadNotice(){
        window.open("/noticeInfiniteScroll");
      },
    },

    created() {
      this.realName = "&nbsp;&nbsp;" +(localStorage.getItem("realname")||"");
      //加载菜单
      if(localStorage.getItem("menu")) {
        this.menu = localStorage.getItem("menu");
      }
      else {
        axios.get( SERVICE_IP_PORT + '/menu/getHtmlMenu3.sp?RESOURCE_IP_PORT='+RESOURCE_IP_PORT
            +'&SERVICE_IP_PORT='+SERVICE_IP_PORT)
            .then((data) => {
                this.menu = data.data.menuHtml3;
                localStorage.setItem("menu", this.menu);
            });
      }

      if(!localStorage.getItem("resources")||localStorage.getItem("resources")=="undefined") {
        axios.get(SERVICE_IP_PORT + '/api/sys/getResource.sp')
            .then((data) => {
                console.log(data);
                localStorage.setItem("resources",JSON.stringify(data.data.resources));
            }).catch(error => {
           console.log(error);
        });
      }
    },

    async mounted() {
      that = this;

      //Active Menu
      let m = this.$route.query.m;
      if(m) {
        activeMenu(m);
      }
      //Binding Action
      handleInit();
      handleHeaderMenu();

      this.getTotalUnReadNoticeNum();
      setInterval(this.getTotalUnReadNoticeNum, that.stayIndexSeconds);
      // setInterval(this.getTotalUnReadNoticeNum, 1000*60);

    }
  }
  </script>

